<app-header></app-header>
<div class="mainWrapper">
  <app-top-banner></app-top-banner>  
  <app-about-company></app-about-company>
  <app-why-chooes></app-why-chooes>
  <app-our-solution></app-our-solution>
  <app-case-studies></app-case-studies>
  <app-footer></app-footer>
</div>